export const getApiErrorMessage = (error: unknown): string | string[] => {
    const data = (error as { response?: { data?: unknown } })?.response?.data;

    if (Array.isArray(data)) {
        return data.map(String);
    }

    if (typeof data === 'string') {
        return data;
    }

    if (data && typeof data === 'object' && 'detail' in data) {
        return String((data as { detail: unknown }).detail);
    }

    if (data) {
        return data as string[];
    }

    return 'error';
};
